import { useState } from 'react'

import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { Button, CircularProgress } from '@mui/material'
import { format } from 'date-fns'
import { toast } from 'react-toastify'

import { ISO_8601_DATE_FORMAT } from 'constants/DateFormats'
import { useGetSupplierActivationExportRowsLazyQuery } from 'generated/graphql'
import { downloadCsv, toCsv } from 'helpers/csv.helpers'

import { useSupplierActivationQueryInput } from './useSupplierActivationQueryInput'

export const SupplierActivationExportButton = () => {
  const [isExporting, setIsExporting] = useState(false)
  const { input, start, end, hasValidRange } = useSupplierActivationQueryInput()
  const [fetchExportRows] = useGetSupplierActivationExportRowsLazyQuery()

  const handleExportCsv = async () => {
    setIsExporting(true)

    try {
      const { data } = await fetchExportRows({ variables: { input } })
      const rows = data?.supplierActivationExportRows ?? []

      if (rows.length === 0) {
        toast.info('There is nothing to export for the selected period.')
        return
      }

      const csv = toCsv(
        ['Section', 'Metric', 'Day', 'Percentage', 'Median days', 'Drivers', 'Eligible drivers'],
        rows.map((row) => [
          row.section,
          row.metric,
          row.day,
          row.percentage,
          row.medianDays,
          row.drivers,
          row.eligible,
        ]),
      )

      const startLabel = start ? format(start, ISO_8601_DATE_FORMAT) : ''
      const endLabel = end ? format(end, ISO_8601_DATE_FORMAT) : ''

      downloadCsv(csv, `supplier-activation-${startLabel}-${endLabel}.csv`)
    } catch {
      toast.error('The export could not be generated. Please try again.')
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <Button
      variant='outlined'
      startIcon={isExporting ? <CircularProgress size={16} /> : <FileDownloadOutlinedIcon />}
      disabled={!hasValidRange || isExporting}
      onClick={handleExportCsv}
      sx={{ whiteSpace: 'nowrap', flexShrink: 0, height: 40 }}>
      Export CSV
    </Button>
  )
}
